const TOS_URL = 'https://www.gomantle.com/tos';
const PRIVACY_POLICY_URL = 'https://www.gomantle.com/privacy-policy';
const LINK_CLASSES = 'text-brand underline';

/**
 * Renders the standard `Terms of Service` and `Privacy Policy` link pair used
 * in onboarding/consent footers. Returns inline `<a>` elements joined by
 * "and" — the caller owns the surrounding sentence and wrapper element so the
 * lead-in copy ("By starting your trial…", "By checking this box…", etc.)
 * stays site-specific.
 *
 * Each anchor calls `e.stopPropagation()` so the helper is safe to drop into
 * a clickable parent (e.g. a Checkbox label) without bubbling the click up
 * and toggling the wrapping control.
 */
const LegalLinks = () => (
  <>
    <a
      href={TOS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={LINK_CLASSES}
      onClick={(e) => e.stopPropagation()}
    >
      Terms of Service
    </a>{' '}
    and{' '}
    <a
      href={PRIVACY_POLICY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={LINK_CLASSES}
      onClick={(e) => e.stopPropagation()}
    >
      Privacy Policy
    </a>
  </>
);

LegalLinks.displayName = 'LegalLinks';

export default LegalLinks;
